import defaultConfig from "./config.default";
import localConfig from "./config.local";

const getEnvConfig = (envConfig = {}) => {
  const deploymentEnv = process.env.REACT_APP_SPS_WEBFORM_DEPLOYMENT_ENV;
  const hostname = process.env.REACT_APP_SPS_WEBFORM_SERVER_HOSTNAME;
  const baseURL = process.env.REACT_APP_SPS_WEBFORM_BASE_URL;
  const apiVersion = process.env.REACT_APP_SPS_WEBFORM_API_VERSION;
  const searchPage = process.env.REACT_APP_SPS_SEARCH_PAGE;
  const homePage = process.env.REACT_APP_SPS_HOME_PAGE;
  const siteKey = process.env.REACT_APP_SPS_WEBFORM_CAPTCHA_SITE_KEY;
  const tacURL = process.env.REACT_APP_SPS_TAC_URL;
  const tacDownloadURL = process.env.REACT_APP_SPS_TAC_DOWNLOAD_URL;
  // you can add other env config like ex: dev:devconfig
  const configs = {
    local: localConfig,
  };
  const deploymentConfig = configs[deploymentEnv]
    ? configs[deploymentEnv]
    : configs.local;

  const config = {
    ...defaultConfig(envConfig),
    ...deploymentConfig(envConfig),
  };
  if (hostname) {
    config.hostname = hostname;
    config.baseURL = baseURL;
    config.apiVersion = apiVersion;
    config.searchPage = searchPage;
    config.homePage = homePage;
    config.siteKey = siteKey;
    config.tacURL = tacURL;
    config.tacDownloadURL = tacDownloadURL;
  }

  return config;
};
export { getEnvConfig };
